import { Link } from '@tanstack/react-router'
import { cn } from '#/lib/utils'

export function Wordmark({ className, size = 'md', to = '/home', compact = false }: { className?: string; size?: 'sm' | 'md' | 'lg'; to?: '/' | '/home'; compact?: boolean }) {
  const sz = size === 'lg' ? 'text-3xl' : size === 'sm' ? 'text-base' : 'text-xl'
  const iconSize = size === 'lg' ? 44 : size === 'sm' ? 28 : 32
  return (
    <Link to={to} className={cn('wordmark brand-lockup select-none', compact && 'brand-lockup-compact', sz, className)} aria-label="Bystep">
      <img src="/brand/mascot-64.png" width={iconSize} height={iconSize} alt="" decoding="async" draggable={false} className="brand-symbol" />
      <span className="brand-name">by<span className="dot">·</span>step</span>
    </Link>
  )
}
